import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { TUXProvider } from '../TUXProvider/TUXProvider.js';

var TUXPortal = function TUXPortal(_ref) {
  var children = _ref.children,
      getContainer = _ref.getContainer;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      mountNode = _useState2[0],
      setMountNode = _useState2[1];

  useEffect(function () {
    var _getContainer;

    if (getContainer === false) {
      return;
    }

    var container = (_getContainer = getContainer === null || getContainer === void 0 ? void 0 : getContainer()) !== null && _getContainer !== void 0 ? _getContainer : document.body;
    setMountNode(container);
  }, [getContainer]);

  if (getContainer === false) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return mountNode ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(TUXProvider, null, children), mountNode) : null;
};

export { TUXPortal };
//# sourceMappingURL=TUXPortal.js.map
